import Modal from "react-bootstrap/Modal";
import { FaCaretRight } from "react-icons/fa6";
import { FaCaretDown } from "react-icons/fa6";
import React, { CSSProperties } from "react";

import { YoutubeContentApiResponse } from "../../../../api/youtubeContentApi";
import YouTubeIframe from "../YouTubeIframe";
import { getScreenWidth } from "../../../../constants";

const YouTubePlayModal = ({ content }: { content: YoutubeContentApiResponse }) => {
  const { isMobile } = getScreenWidth();

  const positionFrameStyle = {
    backgroundColor: "#D9D9D9",
    borderRadius: "13px",
    padding: "5px 10px",
    margin: "0 5px",
  };

  // NOTE: React.CSSProperties で型付けしないと、flexDirection がエラーになる
  // 参考 https://qiita.com/FumioNonaka/items/b32bf5f3070dd7b3a6c9
  const getSummaryBlockStyle = (borderColor: string): CSSProperties => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    border: `1px solid ${borderColor}`,
    borderRadius: "8px",
    backgroundColor: "#F2EFE7",
    padding: "10px",
    minHeight: "180px",
    overflowY: "auto",
  });

  const positionsElement = content.positions?.map((position) => (
    <span key={position.id} style={positionFrameStyle}>
      {position.positionName}
    </span>
  ));

  const referenceElement = (
    <a href={content.reference?.chUrl} target="_blank">
      {content.reference?.chName}
    </a>
  );

  return (
    <>
      <Modal.Header style={{ borderBottom: `5px solid ${content.category?.bgColor}` }} closeButton>
        <Modal.Title id={content.id}>{content.contentName}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: "100vh" }}>
        <div className="text-center">
          <YouTubeIframe url={content.url} />
        </div>
        <div style={getSummaryBlockStyle(content.category?.bgColor || "#ddd")} className="mt-2">
          <div>
            <img src={`${process.env.PUBLIC_URL}/fire.png`} width={20} />
            <span>強化部位</span>
            {isMobile ? (
              <>
                <FaCaretDown />
                <div className="mt-2">{positionsElement}</div>
              </>
            ) : (
              <>
                <FaCaretRight />
                {positionsElement}
              </>
            )}
          </div>
          <div className="mt-2">
            <img src={`${process.env.PUBLIC_URL}/youtube-icon.png`} width={20} />
            <span>引用元チャンネル</span>
            {isMobile ? (
              <>
                <FaCaretDown />
                <div className="mt-2">{referenceElement}</div>
              </>
            ) : (
              <>
                <FaCaretRight />
                {referenceElement}
              </>
            )}
          </div>
          <p className="mt-2">{content.summary}</p>
          <p className="mt-2 mb-0">
            <a href={"#" + content.categoryId} className="me-2">
              #{content.category?.categoryName}
            </a>
            <a href={"#" + content.subCategoryId}>#{content.subCategory?.subCategoryName}</a>
          </p>
        </div>
      </Modal.Body>
    </>
  );
};

export default YouTubePlayModal;
